import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './router.js';
import { ToastProvider } from './components/ui/ToastContext.js';
import { SessionProvider } from './session/SessionContext.js';
// The report template carries the @font-face declarations for both families
// (§4.2). Importing it here means the application screens and the report agree
// on their typefaces instead of only the wizard having them.
import '@pp/report-template/styles.css';
import './styles/global.css';

// Production only: a service worker intercepting fetches during `npm run
// dev` would cache against Vite's own dev server, which rewrites its
// module URLs on every change — exactly the staleness this file exists to
// avoid in production.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js');
  });
}

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

createRoot(container).render(
  <StrictMode>
    <SessionProvider>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </SessionProvider>
  </StrictMode>,
);
